module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-548.e19e111.woff2";